export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.e9db4005.woff2";